import { ObjectLike } from '@/types/objectlike.types';
import { iCover } from './game.types';

export class Cover implements iCover {
  id: number;

  imageId: string;

  width: number;

  height: number;

  url: string;

  constructor(cover: ObjectLike) {
    this.id = cover.id;
    this.imageId = cover.imageId;
    this.width = cover.width;
    this.height = cover.height;
    this.url = cover.url;
  }

  get coverBig(): string {
    return this.url.replace('t_thumb', 't_cover_big');
  }
}
